import styled from 'styled-components';
import Icon from '../../_shared/components/Icon';
import { TradeState } from '../../_shared/types/trade';

export const StyledVdpContainer = styled.div`
  grid-column: 2;
  grid-row: 1 / span 2;
  max-width: 516px;
  position: sticky;
  top: 90px;
  height: calc(100vh - 120px);
  overflow-y: scroll;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  margin-top: -30px;
  padding-bottom: ${({ tradeState }) =>
    tradeState === TradeState.active ? '134' : '51'}px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.GRIDVIEW_DESKTOP_WM}) {
    grid-column: 3;
  }
`;

export const StyledInvalidMiniVdp = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  z-index: 4;
  background-color: ${({ theme }) => theme.COLORS.BASE};
`;

export const StyledNothingSelected = styled.div`
  position: relative;
  top: 45%;
  transform: translateY(-50%);
  text-align: center;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const StyledCardClickIcon = styled(Icon).attrs({
  icon: 'TR5-Card_pointer'
})`
  width: 35px;
`;

export const StyledNothingSelectedHeading = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  margin-top: 18px;
`;

export const StyledNothingSelectedSubheading = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  margin-top: 6px;
`;
